import { render, staticRenderFns } from "./FeeDesc.vue?vue&type=template&id=097389b7&"
import script from "./FeeDesc.vue?vue&type=script&lang=js&"
export * from "./FeeDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097389b7')) {
      api.createRecord('097389b7', component.options)
    } else {
      api.reload('097389b7', component.options)
    }
    module.hot.accept("./FeeDesc.vue?vue&type=template&id=097389b7&", function () {
      api.rerender('097389b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeeDesc.vue"
export default component.exports